module.exports = __webpack_public_path__ + "assets/img/yasi.80cb4f7f.png";